import * as Sentry from "@sentry/browser";

export function getIntegrations() {
	const defaultConfig = [
		Sentry.browserTracingIntegration({}),
		Sentry.rewriteFramesIntegration(),
	];

	if (WEBPACK_SENTRY_IS_VIDEO_REPLAY_ENABLED) {
		const replayConfig: Parameters<typeof Sentry.replayIntegration>[0] = {
			maskAllInputs: WEBPACK_SENTRY_IS_MASK_INPUT_ENABLED,
			maskAllText: WEBPACK_SENTRY_IS_MASK_TEXT_ENABLED,
		};

		if (WEBPACK_SENTRY_IS_HEADERS_AND_BODY_LOGGING_ENABLED) {
			replayConfig.networkDetailAllowUrls = [
				window.location.origin,
				WEBPACK_BASE_ADDRESS,
				WEBPACK_BASE_PROXY_ADDRESS,
				WEBPACK_SPORT_STATISTICS_API_ADDRESS,
				WEBPACK_BET_BOOSTER_API_ADDRESS,
			];

			replayConfig.networkRequestHeaders = [
				"shop-id",
				"agency-id",
				"agency-key",
			];
		}

		defaultConfig.push(Sentry.replayIntegration(replayConfig));
	}

	return defaultConfig;
}
